module.exports = __webpack_public_path__ + "static/media/uc_gender_time.8d78fba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uc_gender_time.png
// module id = 367
// module chunks = 0